module.exports = __webpack_public_path__ + "img/xitadel.b04efaff.svg";